import { useMutation } from "@tanstack/react-query";
import axios from "axios";

interface UpdateDocumentTextPayload {
  url: string;
  text: string;
}

const updateDocumentText = async (payload: UpdateDocumentTextPayload) => {
  const { url, text } = payload;
  await axios.put(url, text, {
    headers: {
      "Content-Type": "text/plain",
    },
  });
};

export const useUpdateDocumentText = () => {
  return useMutation({
    mutationFn: updateDocumentText,
  });
};
